<template>
  <div class="ch-container">
    <div class="logo-bar">
      <el-row>
        <el-col :span="18">
          <div class="ch-logo-box">
            <logo-view />
            <div class="text" v-if="loginFlag == 1">供应商登录</div>
            <div class="text" v-if="loginFlag != 1">采购方登录</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import logoView from "../../components/logo";
export default {
  components: {
    logoView,
  },
  data() {
    return {
      loginFlag: 1,
    }
  },
  created() {
    if(sessionStorage.getItem('loginFlag')){
      this.loginFlag = sessionStorage.getItem('loginFlag') - 0
    }
  },
};
</script>

<style lang="less" scoped>
.logo-bar {
  padding: 20px 0;
}
.ch-logo-box {
  display: flex;
  align-items: center;
  .text {
    padding-left: 20px;
    margin-left: 20px;
    border-left: 2px solid #efefef;
    font-size: 24px;
    font-weight: 300;
    color: #333333;
  }
}
</style>